import React from 'react'
import './experience.css'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import {BsPatchCheckFill} from 'react-icons/bs'

const Contact = () => {
    return (
      <section id='experience'>
        <h5>My Recent Work</h5>
        <h2>My Experience</h2>
        <div className="experience__container">
          <div className="experience__tabs">
            <Tabs>
              <TabList>
                <Tab>
                  <p>Hyundai GIT America, Inc.</p>
                </Tab>
                <Tab>
                  <p>Vogonet Inc</p>
                </Tab>
                <Tab>
                  <p>Woongjin, INC</p>
                </Tab>
              </TabList>

              <TabPanel>
                <div className="panel-content">
                  <p>Software Engineer @<span className='company'> Hyundai GIT America, Inc.</span></p>
                  <span className='period'>Apr 2022 - Jun 2022</span>
                  <ul>
                    <li>Adopted engineering best practices and delivered highest quality scalable solutions.</li>
                    <li>Designed and implemented scalable application programming interfaces.</li>
                    <li>Paired with fellow engineers to brainstorm ideas, debug problems and review code.</li>
                    <li>Performed development, debugging, optimization and automation to support implementation of products and applications.</li>
                    <li>Developed complex software and systems deploying one or more programming languages.</li>
                    <li>Delivered documentation for design decisions, estimating assumptions, code modules and performance metrics.</li>
                  </ul>
                </div>
              </TabPanel>
              <TabPanel>
                <div className="panel-content">
                <p>Fullstack .Net Developer @<span className='company'> Vogonet Inc.</span></p>
                  <span className='period'>Sep 2018 - Mar 2022</span>
                  <ul>
                    <li>Analysis, design and development of various Web Applications and Windows Applications, Excellent programming skills and string Object-Oriented programming concepts Experience in working with C#, MVC, Visual Studio, MSSQL, AWS, .Net Framework, Entity Framework, DevExpress technologies.</li>
                    <li>Implemented and extensively used the Object-Oriented programming concepts in C# and ASP.Net.</li>
                    <li>Enhanced the applications performance by constantly monitoring the queries by running Execution plans and query optimizations techniques in SQL server.</li>
                    <li>Developed Shipping Management System Software by ShipEngine API.</li>
                    <li>Built Payment Module using API (Authorize.Net, Paypal, AfterPay, ZipPay(QuadPay), AmazonPay, Apple Pay)</li>
                    <li>Optimize MSSQL performance, integrity, and security of the project's databases/schemas.</li>
                    <li>Contribute to the optimization of data management and performance tuning.</li>
                    <li>Develop triggers and stored procedures to manipulate data</li>
                    <li>Create, modify, and troubleshoot SQL queries, stored procedures and jobs.</li>
                    <li>Managed multiple complex web-based software implementation projects using agile methodology while exceeding service levels.</li>
                    <li>Managed code in a GitHub and Team Foundation environment.</li>
                    <li>Performed application server builds in AWS environment.</li>
                  </ul>
                </div>
              </TabPanel>
              <TabPanel>
                <div className="panel-content">
                <p>Application Developer @<span className='company'> Woongjin, INC.</span></p>
                  <span className='period'>Aug 2017 - Aug 2018</span>
                  <ul>
                    <li>Applied emerging technologies to update and maintain site applicability.</li>
                    <li>Design, implemented, and monitored web pages, plugins and functionality for continuous improvement.</li>
                    <li>Planned website development, converting mockups into usable web presence with HTML, JavaScript, AJAX and JSON coding.</li>
                    <li>Used Classic ASP, PHP and Ext JS to design and develop numerous ECommerce site and web-based solutions, both front end and back end.</li>
                    <li>Troubleshoot and fixed any threads</li>
                  </ul>
                </div>
              </TabPanel>
            </Tabs>
          </div>
        </div>
        
      </section>
    )
  }
  
  export default Contact